import * as React from 'react';
import * as Utils from '../Utils';

export interface IDurationButtonsProps {
  onStart: () => void;
}

export interface IDurationButtonsState {
  durations: number[];
}

const DEFAULT_DURATIONS = [
  1000,
  60000,
  120000,
  300000,
  900000,
  1800000
];

export default class DurationButtons extends React.Component<IDurationButtonsProps, IDurationButtonsState> {

  constructor(props: IDurationButtonsProps) {
    super(props);
    this.state = {
      durations: this.getDurationsFromLocalStorage(),
    }
    this.renderButtons = this.renderButtons.bind(this);
    this.onClick = this.onClick.bind(this);
    this.addButton = this.addButton.bind(this);
    this.removeButton = this.removeButton.bind(this);
  }

  public render() {
    return (
      <div>
        {this.renderButtons()}
      </div>
    );
  }

  private renderButtons() {
    return (
      <>
        {this.state.durations.map(dur => {
          return this.button(Utils.getLabel(dur), dur)
        })}
        <button
          type="button"
          className="btn btn-primary btn-lg m-2"
          onClick={this.addButton}
        >
          {"➕"}
        </button>
      </>
    )
  }

  private button(label: string, durationMs: number) {
    return (
      <button
        type="button"
        key={durationMs}
        className="btn btn-primary btn-lg m-2"
        data-duration={durationMs}
        onClick={this.onClick}
      >
        {label}&nbsp;<span className="badge badge-light" data-duration={durationMs} onClick={this.removeButton}>X</span>
        <span className="sr-only">delete button</span>
      </button>
    )
  }

  private addButton(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    const ans = prompt("Period of time in seconds (1 day max.):", "3600*24-10");
    if (ans && /[0-9*+-]+/.test(ans)) {
      // tslint:disable-next-line:no-eval
      const newDuration = eval(ans) * 1000;
      if (newDuration > 0 && newDuration <= 3600 * 24 * 1000 && this.state.durations.indexOf(newDuration) < 0) {
        const newDurations = [...this.state.durations, newDuration];
        newDurations.sort((a, b) => a - b);
        window.localStorage.setItem("durations", JSON.stringify(newDurations));
        this.setState({
          durations: newDurations
        });
      }
    }
  }

  private removeButton(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.stopPropagation();
    const durationMs = parseInt(event.currentTarget.getAttribute("data-duration") || "0", 10);
    const newDurations = this.state.durations.filter(dur => dur !== durationMs);
    window.localStorage.setItem("durations", JSON.stringify(newDurations));
    this.setState(prevState => ({
      durations: newDurations
    }));
  }

  private onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    const durationMs = event.currentTarget.getAttribute("data-duration");
    if (durationMs) {
      window.localStorage.setItem("duration", durationMs);
      this.props.onStart();
    }
  }

  private getDurationsFromLocalStorage() {
    const storage = window.localStorage.getItem("durations");
    if (storage) {
      return JSON.parse(storage);
    } else {
      return DEFAULT_DURATIONS;
    }
  }
}



// WEBPACK FOOTER //
// ./src/Timer/DurationButtons.tsx